import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import QNELogo from '../assets/infiniti-name-logo.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Button} from "react-bootstrap";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

    const handleClick = () => {
      const pathAfterEn = location.pathname.replace('/en/', '');

      switch (pathAfterEn) {
        case 'contactus':
          navigate('/cn/contactus');
          break;
        case 'aboutus':
          navigate('/cn/aboutus');
          break;
        default:
          navigate('/cn/');
          break;
      }
  }
  return (
    <Navbar expand="lg" className='navbar'>
    <Container>
      <Navbar.Brand href="./ "><img src={QNELogo} alt='logo' className="qne-logo"></img></Navbar.Brand>
      <Button className="language-btn language-btn-center" onClick={handleClick}>EN</Button>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link className='navlink-text' href="./">Home</Nav.Link>
          <Nav.Link className='navlink-text' href="./aboutus">About Us</Nav.Link>
          <Nav.Link className='navlink-text' href="./contactus">Contact Us</Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <Button className="language-btn language-btn-right" onClick={handleClick}>EN</Button>
    </Container>
  </Navbar>
  )
}

export default Header
